'use strict';

/*global isEmpty*/
/*global services*/

function Notifications() {
    this.$pageSavedMsg = null;
    this.savedInfoTimeout = null;

    this.init();
}

Notifications.prototype = $.extend({}, {
    construtor: 'Notifications',

    //**************************************************************************

    viewMsg: function viewMsg(title, message) {
        var modal = services.get('modal');
        modal.empty().open({
            title: title,
            content: '<p>' + message + '</p>',
            headerClass: 'bg-danger',
            height: 'auto',
            form: false
        });
    },

    viewPageSavedMsg: function viewPageSavedMsg() {
        var _this = this;

        _this.$pageSavedMsg.removeClass('hvr-ripple-out').removeClass('autostart');
        _this.$pageSavedMsg.fadeIn('slow', function () {
            _this.$pageSavedMsg.addClass('hvr-ripple-out').addClass('autostart');
        });
        clearTimeout(_this.savedInfoTimeout);
        _this.savedInfoTimeout = setTimeout(function () {
            _this.$pageSavedMsg.fadeOut('slow');
        }, 3000);
    },

    buildPageSavedMsg: function buildPageSavedMsg() {
        var _this = this;

        var html = '';
        html += '<div id="pageSavedMsg">';
        html +=     '<div>';
        html +=         '<div class="icon">';
        html +=             '<i class="fa fa-save"></i>';
        html +=         '</div>';
        html +=         '<h6>' + services.get('translator').trans('PageSave_title') + '</h6>';
        html +=     '</div>';
        html += '</div>';

        _this.$pageSavedMsg = $(html);

        $('body').append(_this.$pageSavedMsg);

        return _this;
    },

    //**************************************************************************
    init: function init() {
        var _this = this;

        _this.buildPageSavedMsg();

        return _this;
    }
});
